module.exports = __webpack_public_path__ + "media/images/icons/phone-87b37a2180f2ab199377568112337169.png";